// extracted by mini-css-extract-plugin
export var active = "_la-2";
export var recordingDot = "_la-1";
export var recordingIndicator = "_la-0";